import { chipComponent } from '../../components/Chips/Chip/component';
import { uiHeadings } from './componentsDefinitions/uiHeadings';
import { articleHeadings } from './componentsDefinitions/articleHeadings';
import { articleParagraphs } from './componentsDefinitions/articleParagraphs';
import { uiTexts } from './componentsDefinitions/uiTexts';
import {
  offersListComponent,
  offersListLazyWrapperComponent,
  lazyOffersListComponent,
} from '../../components/OffersList';
import { IComponentDefinition } from './types';
import { buttons } from './componentsDefinitions/buttons';
import { citiesProviderComponent } from '../../components/Chips/CitiesProvider/component';
import { otherText } from './componentsDefinitions/otherText';
import { accordion } from './componentsDefinitions/accordion';

// Реестр компонентов
export const reactComponentsRegistry = {
  // UI Headings
  ...uiHeadings,

  // Article Headings
  ...articleHeadings,

  // Article Paragraphs
  ...articleParagraphs,

  // UI Text
  ...uiTexts,

  // Другие текстовые компоненты
  ...otherText,

  // Кнопки
  ...buttons,

  // Аккордеон
  ...accordion,

  // Список офферов
  OffersList: offersListComponent,

  // Lazy load для списка офферов
  OffersListLazyWrapper: offersListLazyWrapperComponent,

  // Во избежание проблем с версткой объединил Wrapper и OffersList на уровне реакта
  LazyOffersList: lazyOffersListComponent,

  // Чип города
  Chip: chipComponent,
  // Провайдер города
  CitiesProvider: citiesProviderComponent,
} as const satisfies Record<string, IComponentDefinition>;

// Оптимизированный индекс для быстрого поиска компонентов по имени тега
export const componentsByTagName = Object.values(reactComponentsRegistry).reduce(
  (acc, comp) => {
    acc[comp.tagName.toLowerCase()] = comp;

    return acc;
  },
  {} as Record<string, IComponentDefinition>,
);

// Вспомогательная функция для получения всех компонентов
export function getAllComponents(): IComponentDefinition[] {
  return Object.values(reactComponentsRegistry);
}
